import React from 'react';
import { Box, Typography } from '@mui/material';

import { Loading } from 'components/common/Loading';
import { VideoReplay } from 'components/events/overlays/VideoReplay';
import { VideoProcessing } from 'components/events/overlays/VideoProcessing';

import styles from './eventsVideoOverlay.module.scss';

interface EventsVideoOverlayProps {
  loading: boolean;
  ended: boolean;
  processing?: boolean;
  onReplay: () => void;
  error?: Error;
}

export const EventsVideoOverlay = ({ loading, error, ended, processing, onReplay }: EventsVideoOverlayProps) => {
  if (loading) {
    return (
      <Box className={styles.overlay}>
        <Loading />
      </Box>
    );
  }

  if (processing) {
    return (
      <Box className={styles.overlay}>
        <VideoProcessing />
      </Box>
    );
  }

  if (ended && onReplay) {
    return (
      <Box className={styles.overlay}>
        <VideoReplay onReplay={onReplay} />
      </Box>
    );
  }

  if (error) {
    return (
      <Box className={styles.overlay}>
        <Typography className="error-message">Error: {error.message}</Typography>
      </Box>
    );
  }

  return <Box className={styles.overlay} />;
};
